export const ITEM_SEARCH_OPTIONS = [
  { label: "품목명", value: "name" },
  { label: "메모", value: "memo" },
  { label: "품목분류", value: "category" },
  { label: "품목코드", value: "code" },
  { label: "규격", value: "size" },
  { label: "구분", value: "division" },
]